<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="客户" v-if="findChildren(35)!==-1" name="customer" style="height: 100%;">
				<customer-index />
			</el-tab-pane>
			<el-tab-pane label="公海" v-if="findChildren(36)!==-1" name="customersea" style="height: 100%;">
				<customersea-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import customerIndex from './customer/index.vue'
	import customerseaIndex from './customersea/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if(this.departmentChildren.length!=0){
				this.activeName = this.departmentChildren[0].controller
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			customerIndex,
			customerseaIndex

		}
	}
</script>
